import * as React from "react"
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { useUserApp } from "@hooks"

// Legend is only shown for this customer (custom KPI thresholds)
const LEGEND_CUSTOMER_ID = 30

const LEGEND_ITEMS = [
    {
        title: "Images",
        rules: [
            { positive: true, label: "4 or more images available" },
            { positive: false, label: "Less than 4 images available" }
        ]
    },
    {
        title: "Videos",
        rules: [
            { positive: true, label: "1 or more videos available" },
            { positive: false, label: "0 videos available" }
        ]
    },
    {
        title: "Rating",
        rules: [
            { positive: true, label: "4.5 or more" },
            { positive: false, label: "Less than 4.5" }
        ]
    },
    {
        title: "Reviews",
        rules: [
            { positive: true, label: "5 or more reviews" },
            { positive: false, label: "Less than 5 reviews" }
        ]
    }
]

export default function ProductPageDetailsLegend() {
    const { userCustomer } = useUserApp()

    if (Number(userCustomer) !== LEGEND_CUSTOMER_ID) return null

    return <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 2 }}>
        <IconSeeker icon="circle-info" sx={{ fontSize: "2.5rem", color: "text.secondary", flexShrink: 0 }} />
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, flex: 1 }}>
            {LEGEND_ITEMS.map(({ title, rules }) => <LegendCard key={title} title={title} rules={rules} />)}
        </Box>
    </Box>
}

const LegendCard = ({ title, rules }) => <Box sx={{
    flex: "1 1 180px",
    minWidth: 180,
    px: 2,
    py: 1.5,
    border: "1px solid",
    borderColor: "divider",
    borderRadius: 2,
    backgroundColor: "background.paper"
}}>
    <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}> {title} </Typography>
    <Box sx={{ display: "flex", flexDirection: "column", gap: .75 }}>
        {rules.map(({ positive, label }) => <Box key={label} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box sx={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                flexShrink: 0,
                backgroundColor: positive ? "success.light" : "error.light"
            }} />
            <Typography variant="caption" color="text.secondary"> {label} </Typography>
        </Box>)}
    </Box>
</Box>
